
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import { PersonalInfo, TaxInfo } from '@/store/dueDiligence/types';
import { AccountTypeFlags, OpenAccountMetadataOption } from '@/store/openAccount/types';
import { AccountOpeningMetadataData } from '@/endpoints/types';
import CPOptionDropdownAdapter from '@/components/globals/adapters/CPOptionDropdownAdapter.vue';
import { metadataNumberAdapter, metadataStringAdapter } from '@/utils/metadataAdapters';

@Component({
    components: {
        CPOpenAccountFormSubsection,
        CPOptionDropdownAdapter
    }
})
export default class CPDueDiligenceAccountHolderPersonalInfoDetails extends Vue {
    @Prop({ required: true }) personalInfo!: PersonalInfo;
    @Prop({ required: true }) taxInfo!: TaxInfo;
    @InjectReactive() accountType!: AccountTypeFlags;
    @InjectReactive() readonly viewOnly!: boolean;

    dobDay = '';
    dobMonth = '';
    dobYear = '';
    metadataStringAdapter = metadataStringAdapter;
    metadataNumberAdapter = metadataNumberAdapter;

    get rawCountries(): AccountOpeningMetadataData[] {
        return this.$store.getters['dueDiligence/rawCountries'];
    }

    get usaCodeId(): number | undefined {
        return this.rawCountries.find(country => country.Text.trim() === "United States of America")?.Value
    }

    updateBirthDate() {
        const d = parseInt(this.dobDay, 10);
        const m = parseInt(this.dobMonth, 10);
        const y = parseInt(this.dobYear, 10);

        const isValid = !isNaN(d) && !isNaN(m) && !isNaN(y) && 
                       m >= 1 && m <= 12 && 
                       d >= 1 && d <= 31;

        if (isValid) {
            this.$set(this.personalInfo, 'BirthDate', new Date(y, m - 1, d));
        } else {
            this.$set(this.personalInfo, 'BirthDate', null);
        }
    }

    handleNationalityInput(nationality: number) {
        this.$set(this.personalInfo, 'Nationality', nationality);
        this.$set(this.taxInfo, 'IsUSTaxResident', nationality === this.usaCodeId);
    }

    mounted() {
        if (this.personalInfo.BirthDate) {
            this.dobDay = String(this.personalInfo.BirthDate.getDate()).padStart(2, '0');
            this.dobMonth = String(this.personalInfo.BirthDate.getMonth() + 1).padStart(2, '0');
            this.dobYear = String(this.personalInfo.BirthDate.getFullYear());
        }
    }
}
